var render = function render(_c,_vm){return (_vm.props.isCapsOn)?_c('div',{staticClass:"caps-lock-wrapper"},[_c('span',[_vm._v(_vm._s(_vm.props.capsOnText))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }